export default __webpack_public_path__ + "static/media/ETH-ON.106fa798.png";